<template>
  <div>
    <div class="bg">
      <div class="flex flex-between item-center">
        <div class="flex item-center">
          <el-button size="small" @click="addGetcashAccount" class="mr10" type="primary"
          >添加提现账号</el-button
          >
          <div class="primary title-wrapper">对私账户只能有一个(正常状态)</div>
          <div class="flex item-center ml20">
            <div>商户分成对导购是否可见</div>
            <el-select v-model="lookSotreShareAuthFlag" @change="switchLookAuth" class="ml10" size="small" placeholder="请选择">
              <el-option
                  v-for="item in lookSotreShareAuthList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <el-input v-model="searchCondition.keyWord" placeholder="请输入电话/注册名" size="small" class="mr20" clearable></el-input>
          <el-button size="small" @click="search" type="primary"
          >查询</el-button
          >
        </div>
      </div>
    </div>
    <hm-content class="mt10">
      <div class="flex flex-end item-center">
        <div @click="outputExcel" class="delete mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出模板
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入
          <input
              type="file"
              @change="importf"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
      <div class="mt20">
        <el-table
            :data="list"
            stripe
            border
            size="small"
            style="width: 100%">
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
              prop="guiderName"
              header-align="center"
              align="center"
              label="注册名">
          </el-table-column>
          <el-table-column
              prop="guiderPhone"
              label="绑定电话"
              header-align="center"
              align="center">
          </el-table-column>
          <el-table-column
              prop="accountType"
              label="账户类型"
              header-align="center"
              align="center">
            <template slot-scope="scope">
              {{ scope.row.accountType == "corporate" ? "对公账户" : "对私账户" }}
            </template>
          </el-table-column>
          <el-table-column
              prop="shareRatio"
              label="状态"
              header-align="center"
              align="center">
            <template slot-scope="scope">
                <div v-if="scope.row.accountState == 'open'" style="color: #2FC348">开启</div>
                <div v-else style="color: #FF7F10">暂停中</div>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="teams"
              label="操作"
              width="350"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button size="small" type="text" style="color: #FF7F10" v-if="scope.row.accountState == 'open'" @click="editAccountState(scope.row, 'close')"
                >暂停</el-button
                >
                <el-button size="small" type="text" style="color: #2FC348" v-else @click="editAccountState(scope.row, 'open')"
                >开启</el-button
                >
                <el-button size="small" type="text" @click="delAccount(scope.row)"
                >移除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>

      <el-dialog
          :close-on-click-modal="false"
          title="添加提现账号"
          width="1600px"
          @close="closeDialog"
          :visible.sync="dialogVisible"
      >
        <div class="flex">
          <div class="left-wrapper">
            <div class="flex flex-end item-center">
              <el-input v-model="dialog.guider.searchCondition.keyWord" placeholder="请输入电话/注册名" size="small" class="mr20" clearable></el-input>
              <el-button size="small" @click="guiderSearch" type="primary"
              >查询</el-button
              >
            </div>
            <div style="margin-top: 70px">
              <el-table
                  :data="dialog.guider.guiderList"
                  stripe
                  border
                  ref="guiderListTable"
                  size="small"
                  @selection-change="guiderHandleSelectionChange"
                  style="width: 100%">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    type="index"
                    label="序号"
                    width="50"
                    :index="index => index + (dialog.guider.guiderCurrentPage - 1) * dialog.guider.guiderPageSize + 1"
                ></el-table-column>
                <el-table-column
                    prop="guiderName"
                    header-align="center"
                    align="center"
                    label="注册名">
                </el-table-column>
                <el-table-column
                    prop="guiderPhone"
                    label="绑定电话"
                    header-align="center"
                    align="center">
                </el-table-column>
              </el-table>
              <div class="hm-pagination">
                <el-pagination
                    background
                    small
                    :pager-count="5"
                    :total="dialog.guider.guiderTotal"
                    @current-change="guiderPaging"
                    @size-change="guiderHandleSizeChange"
                    layout="total,sizes,  prev, pager, next, jumper"
                    :current-page="dialog.guider.guiderCurrentPage"
                ></el-pagination>
              </div>
            </div>
          </div>
          <div class="centre-wrapper flex item-center flex-center">
            <el-button size="small" @click="selectedGuider" type="primary"
            >选择勾选注册名</el-button
            >
          </div>
          <div class="flex-1">
            <div class="flex flex-end item-center">
              <el-input v-model="dialog.selected.searchCondition.keyWord" placeholder="请输入商户名称" size="small" class="mr20" clearable></el-input>
              <el-button size="small" @click="selectedSearch" type="primary"
              >查询</el-button
              >
            </div>
            <div class="flex flex-end item-center mt20">
              <div class="mr10">批量设置类型</div>
              <el-select v-model="accountType" placeholder="请选择" class="mr20" size="small" @change="changeSelectedAccountType">
                <el-option
                    v-for="(item, i) in options"
                    :key="i"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
            </div>
            <div class="mt20">
              <el-table
                  :data="dialog.selected.selectedList.filter(
                (data) =>
              !dialog.selected.searchCondition.searchKeyWord ||
              data.guiderName
              .toLowerCase()
              .includes(dialog.selected.searchCondition.searchKeyWord.toLowerCase()) ||
              data.guiderName
              .toLowerCase()
              .includes(dialog.selected.searchCondition.searchKeyWord.toLowerCase()) ||
              data.guiderPhone
              .toLowerCase()
              .includes(dialog.selected.searchCondition.searchKeyWord.toLowerCase()) ||
              data.guiderPhone
              .toLowerCase()
              .includes(dialog.selected.searchCondition.searchKeyWord.toLowerCase())
              )"
                  stripe
                  border
                  ref="selectedTable"
                  max-height="500"
                  size="small"
                  @selection-change="selectedHandleSelectionChange"
                  style="width: 100%">
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    type="index"
                    label="序号"
                    width="50"
                    :index="index => index + 1"
                ></el-table-column>
                <el-table-column
                    prop="guiderName"
                    header-align="center"
                    align="center"
                    label="注册名">
                </el-table-column>
                <el-table-column
                    prop="guiderPhone"
                    label="绑定电话"
                    header-align="center"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="accountType"
                    label="类型"
                    header-align="center"
                    align="center">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.accountType" placeholder="请选择" class="mr20" size="small">
                      <el-option
                          v-for="(item, i) in options"
                          :key="i"
                          :label="item.name"
                          :value="item.code">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="teams"
                    label="操作"
                    width="80"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-button size="small" type="text" @click="delSelected(scope.row)"
                      >删除</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="mt40 flex flex-center">
          <el-button  size="small" @click="dialogVisible = false"
          >取消</el-button
          >
          <el-button type="primary" size="small" @click="submit"
          >确定</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
          :close-on-click-modal="false"
          title="失败结果"
          width="800px"
          :visible.sync="errDialogVisible"
      >
        <div>
          <div>
            您有<span class="primary">{{ errList.length }}</span>条数据添加失败,
            <span class="error">{{ succList.length }}</span
            >条数据添加成功
          </div>
          <el-table :data="errList" border class="small-table mt20" size="small">
            <el-table-column
                header-align="center"
                align="center"
                prop="guiderName"
                label="注册名">
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="guiderPhone"
                label="电话">
            </el-table-column>
            <!-- <el-table-column prop="mobile" label="手机号"></el-table-column> -->
          </el-table>
        </div>
      </el-dialog>
    </hm-content>
  </div>
</template>

<script>
import XLSX from "xlsx";
import {arrayUnique2, getSubtract} from "@/utils/utils";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        keyWord: ""
      },
      dialogVisible: false,
      dialog: {
        guider: {
          guiderList: [],
          guiderSelection: [],
          guiderCurrentPage: 1,
          guiderPageSize: 10,
          guiderTotal: 0,
          searchCondition: {
            keyWord: ""
          }
        },
        selected: {
          selectedList: [],
          selectedSelection: [],
          searchCondition: {
            keyWord: "",
            searchKeyWord: ""
          }
        }
      },
      accountType: "",
      options: [
        {
          code: "corporate",
          name: "对公账户"
        },
        {
          code: "private",
          name: "对私账户"
        }
      ],
      errDialogVisible: false,
      errList: [],
      succList: [],
      lookSotreShareAuthList: [
        {
          label: "可查看",
          value: "yes",
        },
        {
          label: '不可查看',
          value: "no",
        }
      ],
      lookSotreShareAuthFlag: "yes",
      currentLookAuth: "",
    };
  },
  created() {},
  mounted() {
    this.queryList();
    this.queryLookAuth();
  },
  methods: {
    async queryLookAuth() {
      let params = {
        storeCode: this.$route.query.storeCode
      }
      const { result } = await this.$store.dispatch("queryLookAuth", params);
      this.currentLookAuth = result;
      this.lookSotreShareAuthFlag = result;
    },
    async editLookAuth(flag) {
      let params = {
        storeCode: this.$route.query.storeCode,
        value: flag
      };
      await this.$store.dispatch("editLookAuth", params);
      this.$message({
        message: "操作成功",
        type: "success"
      });
      this.queryLookAuth();
    },
    switchLookAuth(val) {
      console.log("val", val);
      this.$confirm('此操作将修改导购查看商户分成数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.editLookAuth(val);
      }).catch(() => {
        this.lookSotreShareAuthFlag = this.currentLookAuth;
      });
    },
    selectedSearch() {
      this.dialog.selected.searchCondition.searchKeyWord = this.dialog.selected.searchCondition.keyWord;
      this.$refs.selectedTable.toggleAllSelection();
    },
    delAccount(row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = JSON.parse(JSON.stringify(row));
        await this.$store.dispatch("delStoreShareGuider", params);
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.queryList();
      }).catch(() => {

      });
    },
    async editAccountState(row, state) {
      let params = JSON.parse(JSON.stringify(row));
      params.accountState = state;
      await this.$store.dispatch("editStoreShareGuiderAccountState", params);
      this.$message({
        message: "操作成功",
        type: "success"
      });
      this.queryList();
    },
    closeDialog() {
      this.dialog.selected.selectedList = [];
      this.dialog.selected.selectedSelection = [];
      this.dialog.guider.guiderList = [];
      this.dialog.guider.guiderSelection = [];
      this.dialog.guider.searchCondition.keyWord = "";
      this.accountType = "";
      this.dialog.selected.searchCondition.keyWord = "";
      this.dialog.selected.searchCondition.searchKeyWord = "";
      this.dialogVisible = false;
    },
    changeSelectedAccountType() {
      this.dialog.selected.selectedSelection.forEach(v => {
        v.accountType = this.accountType;
      })
    },
    async submit() {
      for (let i = 0; i < this.dialog.selected.selectedList.length; i++) {
        if (!this.dialog.selected.selectedList[i].accountType) {
          this.$message({
            message: "请设置账户类型!",
            type: "warning"
          });
          return;
        }
      }
      let params = [];
      this.dialog.selected.selectedList.forEach(v => {
        params.push({
          storeCode: this.$route.query.storeCode,
          guiderId: v.guiderId,
          accountType: v.accountType,
          guiderName: v.guiderName,
          guiderPhone: v.guiderPhone
        })
      });
      const { result } = await this.$store.dispatch("submitStoreShareGuider", params);
      this.$message({
        message: "操作成功",
        type: "success"
      });
      const { succList, errList } = result;
      this.dialogVisible = false;
      this.errList = errList;
      this.succList = succList;
      if (errList && errList.length > 0) {
        this.errDialogVisible = true;
      }
      this.queryList();
    },
    delSelected(row) {
      let list = [];
      list.push(row);
      this.dialog.selected.selectedList = getSubtract(
          this.dialog.selected.selectedList,
          list,
          "guiderId"
      );
      this.$refs.selectedTable.toggleAllSelection();
      this.dialog.guider.guiderList.forEach(v => {
        setTimeout(() => {
          if (row.guiderId == v.guiderId) {
            this.$refs.guiderListTable.toggleRowSelection(v, false);
          }
        }, 0);
      })
    },
    guiderSearch() {
      this.dialog.guider.guiderCurrentPage = 1;
      this.queryGuiderList();
    },
    async queryGuiderList() {
      const params = {
        pageSize: this.dialog.guider.guiderPageSize,
        pageNo: this.dialog.guider.guiderCurrentPage,
        storeCode: this.$route.query.storeCode,
        excludeStoreShareFlag: "yes",
      };
      const searchCondition = JSON.parse(JSON.stringify(this.dialog.guider.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("querySupplierGuiderPageList", params);
      if (code === "0") {
        const { total, records } = result;
        this.dialog.guider.guiderList = records;
        this.dialog.guider.guiderTotal = total;

        if (this.dialog.selected.selectedList && this.dialog.selected.selectedList.length > 0) {
          let guiderIdList = this.dialog.selected.selectedList.map(v => {
            return v.guiderId
          });
          this.dialog.guider.guiderList.forEach(v => {
            setTimeout(() => {
              if (guiderIdList.includes(v.guiderId)) {
                this.$refs.guiderListTable.toggleRowSelection(v, true);
              }
            }, 0);
          })
        }
      }
    },
    selectedGuider() {
      let list = JSON.parse(JSON.stringify(this.dialog.guider.guiderSelection))
      list.forEach(v => {
        v.accountType = "";
      })
      this.dialog.selected.selectedList = this.dialog.selected.selectedList.concat(list);
      this.dialog.selected.selectedList = arrayUnique2(
          this.dialog.selected.selectedList,
          "guiderId"
      );
      this.$refs.selectedTable.toggleAllSelection();
    },
    selectedHandleSelectionChange(val) {
      this.dialog.selected.selectedSelection = val;
    },
    guiderHandleSelectionChange(val) {
      this.dialog.guider.guiderSelection = val;
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "绑定电话",
          "类型(对公corporate/对私private)"
        ];
        const data = [];

        exportJsonToExcel(tHeader, data, "导入提现账号");
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];

        result.forEach(v => {
          if (v[0] && v[1]) {
            formatResult.push({
              guiderPhone: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              accountType: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
              storeCode: that.$route.query.storeCode
            });
          }
        });

        formatResult = arrayUnique2(formatResult, "guiderPhone");

        that.$store
            .dispatch("importStoreShareGuider", formatResult)
            .then(res => {
              const { code, result } = res;
              if (code === "0") {
                that.errList = result.errList;
                that.succList = result.succList;
                if (result.errList.length) {
                  that.errDialogVisible = true;
                  that.$message({
                    message: "部分导入失败！",
                    type: "warning"
                  });
                } else if (result.succList.length) {
                  that.$message({
                    message: "导入成功！",
                    type: "success"
                  });
                }
                that.queryList();
              }
            });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    addGetcashAccount() {
      this.dialogVisible = true;
      this.queryGuiderList();
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        storeCode: this.$route.query.storeCode,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryStoreShareGuiderList", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    selectedPaging(page) {
      this.dialog.selected.selectedCurrentPage = page;
      this.querySelectedList();
    },
    selectedHandleSizeChange(size) {
      this.dialog.selected.selectedCurrentPage = 1;
      this.dialog.selected.selectedPageSize = size;
      this.querySelectedList();
    },
    guiderPaging(page) {
      this.dialog.guider.guiderCurrentPage = page;
      this.queryGuiderList();
    },
    guiderHandleSizeChange(size) {
      this.dialog.guider.guiderCurrentPage = 1;
      this.dialog.guider.guiderPageSize = size;
      this.queryGuiderList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  padding: 20px;
  background-color: #ffffff;
}
.title-wrapper {
  font-size: 12px;
}
.left-wrapper {
  width: 600px;
}
.centre-wrapper {
  width: 150px;
}
</style>
